<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-19 13:57:22
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2023-10-26 11:39:53
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
    </div>
    <div class="main">
      <div class="title-wrap">
        <h2 class="title">添加账号</h2>
      </div>
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
        <div class="plate">
          <div class="title">账户信息</div>
          <el-form-item label="登录账号" prop="loginName">
            <el-col class="col">
              <el-input
                v-model.trim="form.loginName"
                placeholder="请填写登录账号"
                maxlength="30"
              ></el-input>
            </el-col>
            <span class="login-tip">12~20位字符，包含数字、字母。</span>
          </el-form-item>
          <el-form-item label="登录密码" prop="password">
            <el-col class="col">
              <el-input
                v-model.trim="form.password"
                :type="showPassword ? 'text' : 'password'"
                placeholder="请填写登录密码"
                autocomplete="new-password"
                maxlength="30"
              >
                <i
                  slot="suffix"
                  class="iconfont"
                  :class="{
                    'icon-mimaxianshi': showPassword,
                    'icon-mimayincang': !showPassword,
                  }"
                  @click="handleChangePassword('showPassword')"
                ></i>
              </el-input>
            </el-col>
            <span class="login-tip"
              >12~20位字符，包含数字、特殊字符、字母。</span
            >
          </el-form-item>
          <el-form-item label="联系人" prop="contactName">
            <el-col class="col">
              <el-input
                v-model="form.contactName"
                placeholder="请填写姓名"
              ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="手机号码" prop="mobile">
            <el-col class="col">
              <el-input
                v-model.trim="form.mobile"
                placeholder="请填写手机号码"
                oninput="valuevalue.replace(/[^\d]/g,'')"
                maxlength="11"
              ></el-input>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="银行机构" prop="bankName">
            <el-col class="col">
              <el-input
                v-model.trim="form.bankName"
                placeholder="请填写银行机构"
              ></el-input>
            </el-col>
          </el-form-item> -->
          <el-form-item prop="companyName" label="保险机构">
            <el-col class="col">
              <el-autocomplete
                v-model="form.companyName"
                :fetch-suggestions="insureAssociate"
                placeholder="请选择保险机构，输入关键字查询选择"
                label="companyName"
                value="companyId"
                value-key="companyName"
                :trigger-on-focus="false"
                @select="handleSelectInsureAssociate"
                @input="handleInputInsureAssociate"
              ></el-autocomplete>
            </el-col>
          </el-form-item>
          <el-form-item label="业务网点" prop="businessAddress">
            <el-col class="col">
              <el-input
                v-model.trim="form.businessAddress"
                placeholder="请填写保险机构业务网点名称"
              ></el-input>
            </el-col>
            <span class="login-tip">如中国农业银行阜阳支行营业部</span>
          </el-form-item>
          <el-form-item label="划分级别" prop="divideLevel">
            <el-col class="col">
              <el-radio-group
                class="uav-type"
                @change="handleLevel"
                v-model="form.divideLevel"
              >
                <el-radio
                  v-for="item in levels"
                  :label="item.id"
                  :key="item.id"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <el-form-item label="管辖地区" :prop="address">
            <el-col
              class="col col-select"
              :class="'col-select' + form.divideLevel"
            >
              <el-input
                class="my-input"
                disabled
                v-if="form.divideLevel == 1"
                placeholder="全国"
                oninput="valuevalue.replace(/[^\d]/g,'')"
              ></el-input>
              <el-select
                v-if="
                  form.divideLevel == 2 ||
                  form.divideLevel == 3 ||
                  form.divideLevel == 4
                "
                v-model="form.provinceId"
                placeholder="请选择省"
                @change="
                  handleChangeAddress(
                    form.provinceId,
                    'cityList',
                    'provinceName'
                  )
                "
                style="width: 200px"
              >
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item.n"
                  :value="item.i"
                >
                  {{ item.n }}
                </el-option>
              </el-select>
              <el-select
                :disabled="form.provinceId ? false : true"
                v-if="form.divideLevel == 3 || form.divideLevel == 4"
                v-model="form.cityId"
                placeholder="请选择市"
                class="city-select"
                @change="
                  handleChangeAddress(form.cityId, 'areaList', 'cityName')
                "
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.n"
                  :value="item.i"
                >
                  {{ item.n }}
                </el-option>
              </el-select>
              <el-select
                :disabled="form.cityId ? false : true"
                v-if="form.divideLevel == 4"
                v-model="form.areaId"
                placeholder="请选择县"
                class="city-select"
                @change="handleChangeAddress(form.areaId, '', 'areaName')"
              >
                <el-option
                  v-for="(item, index) in areaList"
                  :key="index"
                  :label="item.n"
                  :value="item.i"
                >
                  {{ item.n }}
                </el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="登录地址" prop="subDomain">
            <el-col class="col domain-col">
              <el-input
                v-model="form.subDomain"
                minlength="2"
                maxlength="20"
                placeholder="请填写登录地址"
              >
                <template slot="prepend">http://</template>
                <i slot="suffix"> -baoxian </i>
                <template slot="append">.xiangli360.com</template>
              </el-input>
            </el-col>
            <span class="login-tip tip1"
              >如登录地址为“{{
                form.subDomain ? form.subDomain : "datian"
              }}”，则登录地址为“http://{{
                form.subDomain ? form.subDomain : "datian"
              }}-baoxian.xiangli360.com”；登录地址2~20位，支持数字和小写字母。</span
            >
          </el-form-item>
        </div>
        <div class="plate">
          <div class="title">业务信息</div>
          <el-form-item label="业务区域" prop="businessZoneId">
            <el-col class="col">
              <el-cascader
                ref="regionCascader"
                :options="businessZoneList"
                :props="zoneProps"
                v-model="checkedZone"
                placeholder="业务区域"
              ></el-cascader>
            </el-col>
          </el-form-item>
          <el-form-item label="业务负责人" prop="businessPersonId">
            <el-col class="col">
              <el-select
                v-model="form.businessPersonId"
                placeholder="业务负责人"
              >
                <!-- <el-option label="全部" :value="null"></el-option> -->
                <el-option
                  v-for="(item, index) in dutyPersonList"
                  :key="index"
                  :label="item.personName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </div>
        <el-form-item class="form-item-submit" label-width="0">
          <el-button
            type="primary"
            @click="handleSubmit('ruleForm')"
            v-loading.fullscreen.lock="fullscreenLoading"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import common from "@/utils/common.js";
export default {
  name: "AddInsure",

  data() {
    const validateCompanyName = (rule, value, callback) => {
      if (this.form.companyId == "") {
        this.form.companyName = "";
        callback(new Error("请选择保险机构"));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,
      rules: {
        companyName: [
          {
            required: true,
            message: "请选择保险机构",
            trigger: "blur",
            validator: validateCompanyName,
          },
        ],
        businessAddress: [
          {
            required: true,
            message: "请填写保险机构业务网点名称",
            trigger: "blur",
          },
        ],
        divideLevel: [
          { required: true, message: "请选择划分级别", trigger: "blur" },
        ],
        provinceId: [
          { required: true, message: "请选择管辖地区", trigger: "change" },
        ],
        cityId: [
          { required: true, message: "请选择管辖地区", trigger: "change" },
        ],
        areaId: [
          { required: true, message: "请选择管辖地区", trigger: "change" },
        ],
        loginName: [
          { required: true, message: "请填写登录账号", trigger: "blur" },
          { min: 6, max: 20, message: "长度在6到20位", trigger: "blur" },
          { trigger: "blur", validator: common.checkIdAccount },
        ],
        password: [
          { required: true, message: "请填写12-20位账号密码", trigger: "blur" },
          {
            min: 6,
            max: 20,
            message: "请输入12-20位账号密码",
            trigger: "blur",
          },
          { trigger: "blur", validator: common.checkIdPassword },
        ],

        contactName: [
          { required: true, message: "请填写联系人名称", trigger: "blur" },
        ],
        mobile: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
          { validator: common.checkMobile, required: true, trigger: "blur" },
        ],
        subDomain: [
          { required: true, message: "请填写登录地址", trigger: "blur" },
          { trigger: "blur", validator: common.checkSubDomain },
          { min: 2, max: 20, message: "长度在4到20位", trigger: "blur" },
        ],
        businessZoneId: [
          { required: true, message: "请选择业务区域", trigger: "change" },
        ],
        businessPersonId: [
          { required: true, message: "请选择业务员", trigger: "change" },
        ],
      },
      form: {
        provinceId: "", //住址省id
        provinceName: "", //住址省name
        cityId: "", //住址市id
        cityName: "", //住址市name
        areaId: "", //所在地区县id
        areaName: "", //所在地区县name
        loginName: "", // 登陆
        mobile: "", // 手机
        contactName: "", // 人
        subDomain: "", // 网址
        businessPersonId: "", // 业务员
        businessZoneId: "", // 业务区域
        password: "", // 密码
        divideLevel: 1, // 划分级别
        companyId: "", // 银行名称
        companyName: "",
        businessAddress: "", //业务网点名称
      },
      businessZoneList: [], //业务区域数据
      zoneProps: {
        value: "id",
        label: "zoneName",
        children: "children",
      },
      checkedZone: [], //选中的业务区域
      dutyPersonList: [], // 业务员列表
      showPassword: false, // 是否展示密码
      levels: [
        { label: "全国级", id: 1 },
        { label: "省级", id: 2 },
        { label: "市级", id: 3 },
        { label: "县级", id: 4 },
      ], // 划分级别列表
      provinceList: [], // 省列表
      cityList: [], // 市列表
      areaList: [], // 区县列表
      loading: false,
    };
  },
  components: {},
  filters: {},
  watch: {
    checkedZone(newVal) {
      this.form.businessPersonId = "";
      this.dutyPersonList = [];
      this.form.businessZoneId =
        newVal.length > 0 ? newVal[newVal.length - 1] : "";
      this.$refs.ruleForm.validateField(["businessZoneId"]);
      newVal.length > 0 && this.getDutyPerson();
    },
  },
  computed: {
    address() {
      let str;
      switch (this.form.divideLevel) {
        case 2:
          str = "provinceId";
          break;
        case 3:
          str = "cityId";
          break;
        case 4:
          str = "areaId";
          break;
      }
      return str;
    },
  },
  created() {
    this.getSelectedCityOptions(1, "provinceList");
    this.getBusinessZoneData();
  },
  mounted() {},
  methods: {
    /**
     * @description: 根据父id查询省市县乡村子地区
     * @param {string} pid 父级id
     * @param {string} type 赋值省市区数组
     * @param {*} name 省市区Name字段
     * @param {*} id 省市区对应数组
     */
    async getSelectedCityOptions(pid, type, name, id, loading) {
      try {
        let { data } = await this.$http.common.getChildRegion({ pid });
        this[type] = data;
        name && this.initCityName(id, name, data, loading);
      } catch (error) {}
    },
    /**
     * @description: 选中select后给name赋值同时获取子级数据
     * @param {*} pid
     * @param {*} type
     * @param {*} name
     * @return {*}
     */
    handleChangeAddress(pid, type, name) {
      let city = {};
      let list = "";
      switch (type) {
        case "cityList":
          this.form.cityId = "";
          this.form.areaId = "";
          this.cityList = [];
          this.areaList = [];
          list = "provinceList";
          break;
        case "areaList":
          this.form.areaId = "";
          this.areaList = [];
          list = "cityList";
          break;
        case "":
          list = "areaList";
          break;
        default:
          break;
      }
      city = this[list].find((item) => {
        return item.i == pid;
      });
      this.form[name] = city.n;
      type && this.getSelectedCityOptions(pid, type);
    },
    /**
     * @Description: change级别
     */
    handleLevel(val) {
      if (val == 1) {
        let _form = this.form;
        _form.provinceId = "";
        _form.cityId = "";
        _form.areaId = "";
      }
    },
    /**
     * @Description: 显示/隐藏 密码
     */
    handleChangePassword(type) {
      this[type] = !this[type];
    },
    // 获取业务负责人
    getDutyPerson() {
      this.$http.common
        .getDutyPerson({ businessZoneId: this.form.businessZoneId })
        .then((res) => {
          this.dutyPersonList = res.data;
        });
    },
    // 获取业务区域数据
    getBusinessZoneData() {
      this.$http.common.getBusinessZoneList({}).then((res) => {
        this.businessZoneList = res.data;
      });
    },
    /**
     * @Description: 保存县账号
     */
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.addCtCountyAccount();
        } else {
        }
      });
    },
    /**
     * @Description: 添加县账号
     */
    async addCtCountyAccount() {
      try {
        let { status } = await this.$http.insure.addInsurAccount(this.form);
        if (status == 1) {
          this.fullscreenLoading = false;
          this.$message.success("添加保险机构账号成功");
          this.$router.push({
            path: "/insure/manage/list",
          });
        }
      } catch (error) {
        this.fullscreenLoading = false;
        console.log(error);
      }
    },
    // 保险机构
    insureAssociate(key, cb) {
      if (key !== "") {
        this.loading = true;
        this.$http.insure
          .queryInsurOreByKey({ key })
          .then(({ data }) => {
            this.loading = false;
            // let arr = data.map( (item,index) => ({name:item,value:index}));
            cb(data); // 渲染回调
          })
          .catch((res) => {
            this.loading = false;
          });
      }
    },
    /**
     * @description: 选择保险机构
     * @Author: juanjuanhui
     * @Date: 2023-10-26 10:38:21
     * @param {*} item
     */
    handleSelectInsureAssociate(item) {
      this.form.companyId = item.id;
      this.$refs.ruleForm.clearValidate("companyName");
    },
    /**
     * @description: 输入保险机构时
     * @Author: juanjuanhui
     * @Date: 2023-10-26 11:22:54
     * @param {*} item
     */
    handleInputInsureAssociate(item) {
      this.form.companyId = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
@import "@/styles/mixin.scss";

.main {
  .title-wrap {
    @include plate-title-mutil;
    height: 44px;
    border-bottom: 1px solid #efefef;
    margin-bottom: 16px;
    padding-bottom: 10px;
    box-sizing: border-box;

    .title {
      font-size: 20px;
      font-weight: bold;
      color: #018388;
    }
  }

  ::v-deep .el-form {
    width: 100%;

    .plate {
      padding: 10px 20px;

      .title {
        font-size: 18px;
        color: #333333;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        &:before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 18px;
          background: #018388;
          border-radius: 3px;
          margin-right: 5px;
        }
      }
    }

    .col {
      width: 360px;

      &.domain-col {
        width: 565px;

        .el-input {
          input {
            text-align: right;
            padding-right: 72px;

            &::-webkit-input-placeholder {
              text-align: left;
            }

            &::-moz-placeholder {
              text-align: left;
            }

            &::-ms-input-placeholder {
              text-align: left;
            }
          }

          .el-input__suffix-inner {
            i {
              display: inline-block;
              height: 100%;
              line-height: 40px;
              color: #606266;
              font-style: inherit;
            }
          }
        }
      }

      &.col-select {
        width: 600px;
        display: flex;
      }

      &.col-select2 {
        width: 200px;
      }

      &.col-select3 {
        width: 400px;
      }

      &.col-select4 {
        width: 600px;
      }
    }

    .login-tip {
      display: inline-block;
      margin-left: 15px;
      color: #999;
      font-size: 12px;
      &.tip1 {
        position: absolute;
        top: 32px;
        margin-left: 0;
      }
    }

    .form-item-submit {
      display: flex;
      align-items: center;
      justify-content: center;

      .el-form-item__content {
        margin-right: 450px;
      }
    }

    .el-form-item {
      margin-bottom: 22px;

      .city-select {
        width: 200px !important;
        margin-left: 10px;
      }
    }

    .el-form-item__content {
      display: flex;

      .el-form-item__error {
        position: relative;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
        padding-top: 0;
      }
    }
  }
}
::v-deep {
  .el-autocomplete {
    width: 100% !important;
  }
  .my-input {
    width: 360px;
  }
}
</style>
